"use client";

import { CcSeoProcess } from "@/components/services/seo/CcSeoProcess";
import type { SeoPageCopy } from "@/components/services/seo/seo-page-copy";

import { AD_PROCESS_ILLUSTRATIONS } from "./ad-process-illustrations";

/**
 * The process section with the advertising drawings. A client wrapper,
 * because drawing components can't be passed as props from the server view.
 */
export function CcAdProcess({ copy }: { copy: SeoPageCopy["process"] }) {
  return <CcSeoProcess copy={copy} illustrations={AD_PROCESS_ILLUSTRATIONS} />;
}
